import Vue from "vue";
import VueAnalytics from "vue-analytics";
import router from "@/router";

export default store => {
	const rejected = !!window.sessionStorage.getItem("consent_rejected");
	const accepted = !!window.localStorage.getItem("consent_accepted");
	store.commit("analytics/updateFromStorage", {
		rejected,
		accepted
	});
	// eslint-disable-next-line prefer-destructuring
	let trackingEnabled = store.state.analytics.accepted;
	Vue.use(VueAnalytics, {
		id: [process.env.VUE_APP_GA_ID],
		disabled: !trackingEnabled,
		router,
		debug: {
			enabled: process.env.NODE_ENV !== "production",
			trace: false,
			// Should it call the google backend
			sendHitTask: process.env.NODE_ENV === "production"
		}
	});

	store.subscribe((mutation, state) => {
		if (!mutation.type.startsWith("analytics")) {
			return;
		}
		if (state.analytics.accepted) {
			window.localStorage.setItem("consent_accepted", true);
		} else {
			window.localStorage.removeItem("consent_accepted");
		}
		if (state.analytics.rejected) {
			window.sessionStorage.setItem("consent_rejected", true);
		} else {
			window.sessionStorage.removeItem("consent_rejected");
		}
		if (store.state.analytics.accepted !== trackingEnabled) {
			// eslint-disable-next-line prefer-destructuring
			trackingEnabled = store.state.analytics.accepted;
			if (trackingEnabled) {
				Vue.$ga.enable();
			} else {
				Vue.$ga.disable();
			}
		}
	});
};
